<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="infoSoForm" autocomplete="off">
  <div nz-row nzGutter="24">
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="educationAndTrainingCode" nzSpan="24">Mã định danh</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="educationAndTrainingCode" type="text" placeholder="Nhập mã" readonly>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="eatProvinceCode" nzSpan="24">Mã cơ sở cấp Tỉnh</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="eatProvinceCode" type="text" placeholder="Nhập mã" [jAutofocus]>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="eatMinistryCode" nzSpan="24">Mã cơ sở cấp Bộ</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="eatMinistryCode" type="text" placeholder="Nhập mã">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="16">
      <nz-form-item>
        <nz-form-label #label nzFor="educationAndTrainingName" nzSpan="24" nzRequired>Tên cơ sở</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="educationAndTrainingName" type="text" placeholder="Nhập tên">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="directlyUnderId" nzSpan="24" nzRequired>Cấp trực thuôc</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="directlyUnderControl" (ascModelChange)="changeDirectlyUnder($event)"
            formControlName="directlyUnderId" [placeholder]="'Chọn Loại hình cơ sở giáo dục'"
            [getListAC]="getDirectlyUnderACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label #label nzSpan="24">Trực thuộc</nz-form-label>
        <nz-select nzMode="tags" nzPlaceHolder="Chọn trực thuộc" [(ngModel)]="listSubordinateTypeSelect"
          [ngModelOptions]="{standalone: true}">
          <nz-option *ngFor="let option of listSo" [nzLabel]="option.educationAndTrainingName" [nzValue]="option.id">
          </nz-option>
        </nz-select>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label #label nzSpan="24" nzRequired>Cấp học/trình độ đào tạo (chọn nhiều)</nz-form-label>
        <nz-select nzMode="tags" nzPlaceHolder="Chọn cấp học" [(ngModel)]="listSchoolLevelSelect"
          [ngModelOptions]="{standalone: true}">
          <nz-option *ngFor="let option of listSchoolLevel" [nzLabel]="option.schoolLevelName" [nzValue]="option.id">
          </nz-option>
        </nz-select>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="6">
      <nz-form-item>
        <nz-form-label #label nzFor="modesOfEducationId" nzSpan="24" nzRequired>Phương thức giáo dục</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
          <asc-autocomplete [ascModel]="ModesOfEducationControl" (ascModelChange)="changeModesOfEducation($event)"
            formControlName="modesOfEducationId" [placeholder]="'Chọn phương thức giáo dục...'"
            [getListAC]="getModesOfEducationACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="6">
      <nz-form-item>
        <nz-form-label #label nzFor="moduleId" nzSpan="24" nzRequired>Phân hệ</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
          <asc-autocomplete [ascModel]="modulesControl" (ascModelChange)="changeModules($event)"
            formControlName="moduleId" [placeholder]="'Chọn phân hệ...'" [getListAC]="getModulesACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="6">
      <nz-form-item>
        <nz-form-label #label nzFor="typeOfEducationId" nzSpan="24" nzRequired>Loại hình cơ sở giáo dục</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="TypeofEducationControl" (ascModelChange)="changeTypeofEducation($event)"
            formControlName="typeOfEducationId" placeholder="Chọn loại cơ sở..." [getListAC]="getTypeofEducationACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="6">
      <nz-form-item>
        <nz-form-label #label nzFor="studyModeId" nzSpan="24" nzRequired>Hình thức giáo dục</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="disStudyModeControl" (ascModelChange)="changeDisStudyMode($event)"
            formControlName="studyModeId" placeholder="Chọn Hình thức giáo dục..." [getListAC]="getDisStudyModeACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label #label nzFor="address" nzSpan="24">Địa chỉ (trụ sở cơ quan)</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <input nz-input formControlName="address" type="text" placeholder="Nhập địa chỉ">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="provinceId" nzSpan="24" nzRequired>Tỉnh thành</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
            formControlName="provinceId" [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="districtId" nzSpan="24" nzRequired>Quận huyện</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="districtControl" (ascModelChange)="changeDistrict($event)"
            formControlName="districtId" [placeholder]="'Chọn quận huyện'" [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="8">
      <nz-form-item>
        <nz-form-label #label nzFor="wardId" nzSpan="24">Phường xã</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
          <asc-autocomplete [ascModel]="wardControl" (ascModelChange)="changeWard($event)" formControlName="wardId"
            [placeholder]="'Chọn phường xã'" [getListAC]="getWardACFn">
          </asc-autocomplete>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <nz-tabset nzType="editable-card" nzHideAdd>
    <nz-tab [nzTitle]="'Thông tin Lãnh Đạo'">
      <nz-divider nzText="Thông tin Lãnh Đạo" nzOrientation="left" nzPlain></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="director" nzSpan="24">Tên lãnh đạo</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="director" type="text" placeholder="Nhập tên GĐ">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="directorEmail" nzSpan="24">Email lãnh đạo</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="directorEmail" type="text" placeholder="Nhập email">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="directorPhoneNumber" nzSpan="24">Điện thoại lãnh đạo</nz-form-label>
            <nz-form-control nzSpan="24">
              <input nz-input formControlName="directorPhoneNumber" type="text" placeholder="Nhập sđt">
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'Thông tin đăng nhập'">
      <nz-divider nzText="Thông tin tài khoản đăng nhập" nzOrientation="left" nzPlain></nz-divider>
      <div nz-row nzGutter="24">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="username" nzSpan="24" nzRequired>Tên đăng nhập</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="username" type="text" placeholder="Nhập tên đăng nhập">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label #label nzFor="password" nzSpan="24" nzRequired>Mật khẩu</nz-form-label>
            <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
              <input nz-input formControlName="password" type="password" placeholder="Nhập mật khẩu">
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8"></div>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="'Thông tin cơ sở vật chất và phương tiện'">

      <nz-divider nzText="Điều kiện đảm bảo để người khuyết tật tham gia giáo dục" nzOrientation="left" nzPlain>
      </nz-divider>

      <div nz-row nzGutter="24">
        <div nz-col nzSpan="24">
          <div nz-row>
            <div nz-col nzSpan="8">
              <nz-form-label #label nzSpan="24"><b>Loại phương tiện, thiết bị, học liệu</b></nz-form-label>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-label #label nzSpan="24" nzRequired><b>Số lượng</b></nz-form-label>
            </div>
            <div nz-col nzSpan="8">
              <nz-form-label #label nzSpan="24" nzRequired><b>Chất lượng</b></nz-form-label>
            </div>
            <!-- ng for -->
            <ng-container formArrayName="listFacilitiesAndEquipment"
              *ngFor="let fAndE of listFacilitiesAndEquipments; let i = index">
              <div nz-col nzSpan="8">
                <nz-form-label #label nzSpan="24">{{i+1}}. {{ fAndE.name }}</nz-form-label>
              </div>
              <ng-container [formGroupName]="i">
                <div nz-col nzSpan="8">
                  <nz-form-item>
                    <nz-form-control nzErrorTip="Vui lòng nhập trường bắt buộc!">
                      <nz-radio-group formControlName="amountStatus">
                        <label nz-radio [nzValue]="1">Đủ</label>
                        <label nz-radio [nzValue]="2">Thiếu</label>
                        <label nz-radio [nzValue]="3">Chưa có</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzSpan="8">
                  <nz-form-item>
                    <nz-form-control nzErrorTip="Vui lòng nhập trường bắt buộc!">
                      <nz-radio-group formControlName="quantityStatus">
                        <label nz-radio [nzValue]="1">Tốt</label>
                        <label nz-radio [nzValue]="2">Đạt</label>
                        <label nz-radio [nzValue]="3">Chưa đạt</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <nz-divider nzText="Thống kê cơ sở hạ tầng ở đơn vị" nzOrientation="left" nzPlain></nz-divider>

      <div nz-row nzGutter="24">
        <div nz-col nzSpan="24">
          <div nz-row>
            <div nz-col nzSpan="12">
              <nz-form-label #label nzSpan="24"><b>Nội dung</b></nz-form-label>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-label #label nzSpan="24" nzRequired><b>Số lượng</b></nz-form-label>
            </div>
            <!-- ng-for -->
            <ng-container *ngIf="codeInfrastructures.length > 0; else default">
              <ng-container formArrayName="listDisInfrastructure"
                *ngFor="let infrastructure of codeInfrastructures;let i = index">
                  <div nz-col nzSpan="12">
                    <nz-form-label #label nzFor="amount" nzSpan="24">{{ i+1 }}. {{ infrastructure.name }}</nz-form-label>
                  </div>
                <ng-container [formGroupName]="i">
                  <div nz-col nzSpan="4">
                    <nz-form-item>
                      <nz-form-control nzErrorTip="Vui lòng nhập trường bắt buộc!">
                        <nz-input-number formControlName="amount" placeholder="Nhập số lượng" [nzMin]="0" [nzMax]="100"
                          [nzStep]="1"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #default>
              <ng-container formArrayName="listDisInfrastructure"
              *ngFor="let infrastructure of listInfrastructures;let i = index">
                <div nz-col nzSpan="12">
                  <nz-form-label #label nzFor="amount" nzSpan="24">{{ i+1 }}. {{ infrastructure.name }}</nz-form-label>
                </div>
              <ng-container [formGroupName]="i">
                <div nz-col nzSpan="4">
                  <nz-form-item>
                    <nz-form-control nzErrorTip="Vui lòng nhập trường bắt buộc!">
                      <nz-input-number formControlName="amount" placeholder="Nhập số lượng" [nzMin]="0" [nzMax]="100"
                        [nzStep]="1"></nz-input-number>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </ng-container>
            </ng-container>
            </ng-template>

          </div>
        </div>
      </div>
    </nz-tab>
  </nz-tabset>
  <div *nzModalFooter>
    <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>
    <button nz-button nzType="primary" (click)="Update()" [disabled]="isDisabled">Lưu & Thêm</button>
    <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu &
      Đóng</button>&nbsp;
  </div>
</form>
